!(function ($) {
  // Initialize request cart from localStorage or create an empty array
  document.addEventListener("DOMContentLoaded", function () {});
})(jQuery);
